import React, { useState, useEffect } from "react";


export default function FormulaireVisa({ onBack, leadData }) {
  const [step, setStep] = useState(1);
  const [showResidentModal, setShowResidentModal] = useState(false);
  const [errors, setErrors] = useState({});

  // 🔢 Paiement / commande
  const [orderId, setOrderId] = useState(null); // numéro de commande
  const [isPaying, setIsPaying] = useState(false); // état du bouton Stripe
  const [paymentError, setPaymentError] = useState(null); // erreur éventuelle

  const [data, setData] = useState({
    // ⚡ Infos venant de la page d'accueil
    country: leadData?.country || "",
    destination: leadData?.destination || "",
    multiPassportLanding: leadData?.multiPassport || false,

    // Page 1
    motifVoyage: "",
    email: "",
    emailConfirm: "",
    prenoms: "",
    nom: "",
    genre: "",
    dateNaissance: "",
    paysNaissance: "",
    lieuNaissance: "",
    // Page 2
    numPasseport: "",
    numPasseportConfirm: "",
    dateDelivrancePasseport: "",
    dateExpirationPasseport: "",
    paysDelivrancePasseport: "",
    nationalitePasseport: "",
    autreNationalite: "",
    paysAutreNationalite: "",
    residentPermanent: "",
    // Page 3 (simplifié)
    etatCivil: "",
    titreEmploi: "",
    paysEmploi: "",
    villeEmploi: "",
    // Page 4
    adresse: "",
    codePostal: "",
    ville: "",
    paysResidence: "",
    // Page 5
    refusVisa: "",
    detailsRefusVisa: "",
    infractionPenale: "",
    detailsInfractionPenale: "",
    tuberculoseRecent: "",
    affection: "",
    // Page 6 – consentement & déclaration
    declarationAcceptee: false,
    declarationNom: "",
    tiersAutorisationAcceptee: false,
  });

  const totalSteps = 6;
  const progress = Math.round((step / totalSteps) * 100);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleYesNo = (field, value) => {
    setData((prev) => ({ ...prev, [field]: value }));
    if (field === "residentPermanent" && value === "oui") {
      setShowResidentModal(true);
    }
  };

  const validateStep = (currentStep) => {
    const newErrors = {};

    if (currentStep === 1) {
      if (!data.motifVoyage) newErrors.motifVoyage = "Choisissez un motif.";
      if (!data.email) newErrors.email = "L’e-mail est obligatoire.";
      if (!data.emailConfirm) newErrors.emailConfirm = "Confirmez votre e-mail.";
      if (data.email && data.emailConfirm && data.email !== data.emailConfirm) {
        newErrors.emailConfirm = "Les deux e-mails ne correspondent pas.";
      }
      if (!data.prenoms) newErrors.prenoms = "Les prénoms sont obligatoires.";
      if (!data.nom) newErrors.nom = "Le nom est obligatoire.";
      if (!data.genre) newErrors.genre = "Sélectionnez un genre.";
      if (!data.dateNaissance)
        newErrors.dateNaissance = "La date de naissance est obligatoire.";
      if (!data.paysNaissance)
        newErrors.paysNaissance = "Le pays de naissance est obligatoire.";
      if (!data.lieuNaissance)
        newErrors.lieuNaissance = "Le lieu de naissance est obligatoire.";
    }

    if (currentStep === 2) {
      if (!data.numPasseport)
        newErrors.numPasseport = "Le numéro de passeport est obligatoire.";
      if (!data.numPasseportConfirm)
        newErrors.numPasseportConfirm = "Confirmez le numéro de passeport.";
      if (
        data.numPasseport &&
        data.numPasseportConfirm &&
        data.numPasseport !== data.numPasseportConfirm
      ) {
        newErrors.numPasseportConfirm =
          "Les numéros de passeport ne correspondent pas.";
      }
      if (!data.dateDelivrancePasseport)
        newErrors.dateDelivrancePasseport = "La date de délivrance est obligatoire.";
      if (!data.dateExpirationPasseport)
        newErrors.dateExpirationPasseport = "La date d’expiration est obligatoire.";
      if (!data.paysDelivrancePasseport)
        newErrors.paysDelivrancePasseport = "Le pays de délivrance est obligatoire.";
      if (!data.nationalitePasseport)
        newErrors.nationalitePasseport =
          "La nationalité indiquée dans le passeport est obligatoire.";

      if (!data.autreNationalite)
        newErrors.autreNationalite =
          "Veuillez indiquer si vous avez une autre nationalité.";
      if (data.autreNationalite === "oui" && !data.paysAutreNationalite) {
        newErrors.paysAutreNationalite =
          "Indiquez le pays de la deuxième nationalité.";
      }

      if (!data.residentPermanent)
        newErrors.residentPermanent =
          "Veuillez répondre à la question sur le statut de résident permanent.";
    }

    if (currentStep === 3) {
      if (!data.etatCivil) newErrors.etatCivil = "L’état civil est obligatoire.";
      if (!data.titreEmploi)
        newErrors.titreEmploi = "L’intitulé du poste / métier est obligatoire.";
      if (!data.paysEmploi) newErrors.paysEmploi = "Le pays d’emploi est obligatoire.";
      if (!data.villeEmploi) newErrors.villeEmploi = "La ville d’emploi est obligatoire.";
    }

    if (currentStep === 4) {
      if (!data.adresse) newErrors.adresse = "L’adresse est obligatoire.";
      if (!data.codePostal) newErrors.codePostal = "Le code postal est obligatoire.";
      if (!data.ville) newErrors.ville = "La ville est obligatoire.";
      if (!data.paysResidence)
        newErrors.paysResidence = "Le pays de résidence est obligatoire.";
    }

    if (currentStep === 5) {
      if (!data.refusVisa)
        newErrors.refusVisa =
          "Indiquez si vous avez déjà eu un refus de visa / d’entrée.";
      if (data.refusVisa === "oui" && !data.detailsRefusVisa) {
        newErrors.detailsRefusVisa = "Merci de détailler le refus.";
      }

      if (!data.infractionPenale)
        newErrors.infractionPenale =
          "Indiquez si vous avez déjà eu une infraction pénale.";
      if (data.infractionPenale === "oui" && !data.detailsInfractionPenale) {
        newErrors.detailsInfractionPenale =
          "Merci de détailler l’infraction (lieu, date, nature, peine).";
      }

      if (!data.tuberculoseRecent)
        newErrors.tuberculoseRecent =
          "Indiquez si vous avez eu un diagnostic de tuberculose ou un contact étroit.";
      if (!data.affection)
        newErrors.affection =
          "Veuillez indiquer si vous souffrez d’une des affections listées.";
    }

    if (currentStep === 6) {
      if (!data.declarationAcceptee)
        newErrors.declarationAcceptee =
          "Vous devez accepter la déclaration du demandeur.";
      if (!data.declarationNom)
        newErrors.declarationNom =
          "Vous devez saisir votre nom pour signer électroniquement.";
      if (!data.tiersAutorisationAcceptee)
        newErrors.tiersAutorisationAcceptee =
          "Vous devez autoriser l’entreprise à agir en tant que tiers.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const nextStep = () => {
    if (validateStep(step)) {
      setStep((s) => Math.min(totalSteps, s + 1));
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const prevStep = () => {
    setStep((s) => Math.max(1, s - 1));
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // ✅ Submit final : génère le numéro de commande + enregistre + Stripe
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateStep(6)) return;
    if (isPaying) return;
  
    setPaymentError(null);
    setIsPaying(true);
  
    const now = Date.now();
    const numeroCommande = "VG-" + now;
  
    const demande = {
      id: now,
      numeroCommande,
      createdAt: new Date().toISOString(),
      status: "en_attente",
      data,
    };
  
    try {
      // ✅ ENVOI DE LA DEMANDE AU BACKEND (PAS À SUPABASE DIRECT)
// ✅ ENREGISTRER LA DEMANDE (Netlify Function)
const saveRes = await fetch("/.netlify/functions/demandes", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify(demande),
});

if (!saveRes.ok) {
  const t = await saveRes.text().catch(() => "");
  throw new Error("Erreur lors de l’enregistrement de la demande: " + t);
}

// ✅ STRIPE (Netlify Function)
const res = await fetch("/.netlify/functions/create-checkout-session", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({
    numeroCommande,
    email: data.email,
  }),
});

if (!res.ok) {
  const t = await res.text().catch(() => "");
  throw new Error("Erreur Stripe backend: " + t);
}

const session = await res.json();

if (session.url) {
  window.location.href = session.url;
} else {
  throw new Error("URL Stripe manquante");
}

    } catch (err) {
      console.error("❌ Erreur globale :", err);
      setPaymentError("Erreur pendant la redirection vers le paiement.");
      setIsPaying(false);
    }
  };
  
  

  return (
    <main className="min-h-screen bg-gray-50 text-slate-800">
      <section className="max-w-3xl mx-auto px-4 md:px-6 py-8 md:py-10">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h1 className="text-2xl md:text-3xl font-extrabold text-indigo-900">
              Formulaire d’autorisation de voyage
            </h1>
            {(data.destination || data.country) && (
              <p className="mt-1 text-[11px] md:text-xs text-slate-600">
                Nationalité :{" "}
                <span className="font-semibold">
                  {data.country || "Non précisé"}
                </span>{" "}
                — Destination :{" "}
                <span className="font-semibold">
                  {data.destination === "usa"
                    ? "États-Unis (ESTA)"
                    : data.destination === "canada"
                    ? "Canada (eTA)"
                    : data.destination === "australie"
                    ? "Australie (ETA)"
                    : "Non précisée"}
                </span>
              </p>
            )}
          </div>
          <button
            type="button"
            onClick={onBack}
            className="text-xs md:text-sm px-3 py-1.5 rounded-lg border border-slate-300"
          >
            Retour à l’accueil
          </button>
        </div>

        {/* Barre de progression */}
        <div className="mb-5">
          <div className="flex justify-between text-[11px] text-slate-600 mb-1">
            <span>Progression</span>
            <span>{progress}%</span>
          </div>
          <div className="w-full h-2 rounded-full bg-slate-200 overflow-hidden">
            <div
              className="h-2 bg-slate-800 transition-all duration-300"
              style={{ width: `${progress}%` }}
            />
          </div>
        </div>

        <form
          onSubmit={handleSubmit}
          className="bg-white rounded-xl shadow-md p-5 md:p-7 space-y-6"
        >
          {/* PAGE 1 */}
          {step === 1 && (
            <div className="space-y-4">
              <h2 className="text-sm md:text-base font-semibold text-indigo-900">
                1. Raison du voyage et identité
              </h2>

              <div>
                <p className="text-xs font-semibold text-slate-700 mb-2">
                  Raison du voyage <span className="text-red-500">*</span>
                </p>
                <div className="grid grid-cols-3 gap-2 text-xs">
                  {[
                    { key: "tourisme", label: "Touristique" },
                    { key: "business", label: "Business" },
                    { key: "transit", label: "Transit" },
                  ].map((m) => (
                    <button
                      key={m.key}
                      type="button"
                      onClick={() =>
                        setData((prev) => ({ ...prev, motifVoyage: m.key }))
                      }
                      className={`border rounded-lg py-2 px-2 ${
                        data.motifVoyage === m.key
                          ? "border-slate-900 bg-slate-100 text-slate-900"
                          : "border-slate-300 bg-white"
                      }`}
                    >
                      {m.label}
                    </button>
                  ))}
                </div>
                {errors.motifVoyage && (
                  <p className="mt-1 text-[11px] text-red-500">
                    {errors.motifVoyage}
                  </p>
                )}
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-semibold text-slate-700">
                    Adresse e-mail <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={data.email}
                    onChange={handleChange}
                    className="mt-1 w-full border border-slate-300 rounded-lg px-3 py-2 text-sm"
                  />
                  {errors.email && (
                    <p className="mt-1 text-[11px] text-red-500">{errors.email}</p>
                  )}
                </div>
                <div>
                  <label className="block text-xs font-semibold text-slate-700">
                    Confirmez l’e-mail <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="email"
                    name="emailConfirm"
                    value={data.emailConfirm}
                    onChange={handleChange}
                    className="mt-1 w-full border border-slate-300 rounded-lg px-3 py-2 text-sm"
                  />
                  {errors.emailConfirm && (
                    <p className="mt-1 text-[11px] text-red-500">
                      {errors.emailConfirm}
                    </p>
                  )}
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-semibold text-slate-700">
                    Prénoms <span className="text-red-500">*</span>
                  </label>
                  <input
                    name="prenoms"
                    value={data.prenoms}
                    onChange={handleChange}
                    className="mt-1 w-full border border-slate-300 rounded-lg px-3 py-2 text-sm"
                  />
                  {errors.prenoms && (
                    <p className="mt-1 text-[11px] text-red-500">{errors.prenoms}</p>
                  )}
                </div>
                <div>
                  <label className="block text-xs font-semibold text-slate-700">
                    Nom <span className="text-red-500">*</span>
                  </label>
                  <input
                    name="nom"
                    value={data.nom}
                    onChange={handleChange}
                    className="mt-1 w-full border border-slate-300 rounded-lg px-3 py-2 text-sm"
                  />
                  {errors.nom && (
                    <p className="mt-1 text-[11px] text-red-500">{errors.nom}</p>
                  )}
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                  <label className="block text-xs font-semibold text-slate-700">
                    Genre <span className="text-red-500">*</span>
                  </label>
                  <select
                    name="genre"
                    value={data.genre}
                    onChange={handleChange}
                    className="mt-1 w-full border border-slate-300 rounded-lg px-3 py-2 text-sm"
                  >
                    <option value="">Sélectionnez</option>
                    <option value="femme">Femme</option>
                    <option value="homme">Homme</option>
                    <option value="autre">Autre</option>
                  </select>
                  {errors.genre && (
                    <p className="mt-1 text-[11px] text-red-500">{errors.genre}</p>
                  )}
                </div>
                <div>
                  <label className="block text-xs font-semibold text-slate-700">
                    Date de naissance <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="date"
                    name="dateNaissance"
                    value={data.dateNaissance}
                    onChange={handleChange}
                    className="mt-1 w-full border border-slate-300 rounded-lg px-3 py-2 text-sm"
                  />
                  {errors.dateNaissance && (
                    <p className="mt-1 text-[11px] text-red-500">
                      {errors.dateNaissance}
                    </p>
                  )}
                </div>
                <div>
                  <label className="block text-xs font-semibold text-slate-700">
                    Pays de naissance <span className="text-red-500">*</span>
                  </label>
                  <input
                    name="paysNaissance"
                    value={data.paysNaissance}
                    onChange={handleChange}
                    className="mt-1 w-full border border-slate-300 rounded-lg px-3 py-2 text-sm"
                  />
                  {errors.paysNaissance && (
                    <p className="mt-1 text-[11px] text-red-500">
                      {errors.paysNaissance}
                    </p>
                  )}
                </div>
              </div>

              <div>
                <label className="block text-xs font-semibold text-slate-700">
                  Lieu de naissance (ville) <span className="text-red-500">*</span>
                </label>
                <input
                  name="lieuNaissance"
                  value={data.lieuNaissance}
                  onChange={handleChange}
                  className="mt-1 w-full border border-slate-300 rounded-lg px-3 py-2 text-sm"
                />
                {errors.lieuNaissance && (
                  <p className="mt-1 text-[11px] text-red-500">
                    {errors.lieuNaissance}
                  </p>
                )}
              </div>
            </div>
          )}

          {/* PAGE 2 */}
          {step === 2 && (
            <div className="space-y-4">
              <h2 className="text-sm md:text-base font-semibold text-indigo-900">
                2. Passeport
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-semibold text-slate-700">
                    Numéro de passeport <span className="text-red-500">*</span>
                  </label>
                  <input
                    name="numPasseport"
                    value={data.numPasseport}
                    onChange={handleChange}
                    className="mt-1 w-full border border-slate-300 rounded-lg px-3 py-2 text-sm"
                  />
                  {errors.numPasseport && (
                    <p className="mt-1 text-[11px] text-red-500">
                      {errors.numPasseport}
                    </p>
                  )}
                </div>
                <div>
                  <label className="block text-xs font-semibold text-slate-700">
                    Confirmez le numéro de passeport{" "}
                    <span className="text-red-500">*</span>
                  </label>
                  <input
                    name="numPasseportConfirm"
                    value={data.numPasseportConfirm}
                    onChange={handleChange}
                    className="mt-1 w-full border border-slate-300 rounded-lg px-3 py-2 text-sm"
                  />
                  {errors.numPasseportConfirm && (
                    <p className="mt-1 text-[11px] text-red-500">
                      {errors.numPasseportConfirm}
                    </p>
                  )}
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-semibold text-slate-700">
                    Date de délivrance <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="date"
                    name="dateDelivrancePasseport"
                    value={data.dateDelivrancePasseport}
                    onChange={handleChange}
                    className="mt-1 w-full border border-slate-300 rounded-lg px-3 py-2 text-sm"
                  />
                  {errors.dateDelivrancePasseport && (
                    <p className="mt-1 text-[11px] text-red-500">
                      {errors.dateDelivrancePasseport}
                    </p>
                  )}
                </div>
                <div>
                  <label className="block text-xs font-semibold text-slate-700">
                    Date d’expiration <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="date"
                    name="dateExpirationPasseport"
                    value={data.dateExpirationPasseport}
                    onChange={handleChange}
                    className="mt-1 w-full border border-slate-300 rounded-lg px-3 py-2 text-sm"
                  />
                  {errors.dateExpirationPasseport && (
                    <p className="mt-1 text-[11px] text-red-500">
                      {errors.dateExpirationPasseport}
                    </p>
                  )}
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-semibold text-slate-700">
                    Pays de délivrance <span className="text-red-500">*</span>
                  </label>
                  <input
                    name="paysDelivrancePasseport"
                    value={data.paysDelivrancePasseport}
                    onChange={handleChange}
                    className="mt-1 w-full border border-slate-300 rounded-lg px-3 py-2 text-sm"
                  />
                  {errors.paysDelivrancePasseport && (
                    <p className="mt-1 text-[11px] text-red-500">
                      {errors.paysDelivrancePasseport}
                    </p>
                  )}
                </div>
                <div>
                  <label className="block text-xs font-semibold text-slate-700">
                    Nationalité indiquée dans le passeport{" "}
                    <span className="text-red-500">*</span>
                  </label>
                  <input
                    name="nationalitePasseport"
                    value={data.nationalitePasseport}
                    onChange={handleChange}
                    className="mt-1 w-full border border-slate-300 rounded-lg px-3 py-2 text-sm"
                  />
                  {errors.nationalitePasseport && (
                    <p className="mt-1 text-[11px] text-red-500">
                      {errors.nationalitePasseport}
                    </p>
                  )}
                </div>
              </div>

              <div>
                <p className="text-xs font-semibold text-slate-700">
                  Autre nationalité ? <span className="text-red-500">*</span>
                </p>
                <div className="mt-1 flex gap-3 text-xs">
                  <button
                    type="button"
                    onClick={() => handleYesNo("autreNationalite", "oui")}
                    className={`px-3 py-1 rounded-lg border ${
                      data.autreNationalite === "oui"
                        ? "border-slate-900 bg-slate-100"
                        : "border-slate-300 bg-white"
                    }`}
                  >
                    Oui
                  </button>
                  <button
                    type="button"
                    onClick={() => handleYesNo("autreNationalite", "non")}
                    className={`px-3 py-1 rounded-lg border ${
                      data.autreNationalite === "non"
                        ? "border-slate-900 bg-slate-100"
                        : "border-slate-300 bg-white"
                    }`}
                  >
                    Non
                  </button>
                </div>
                {errors.autreNationalite && (
                  <p className="mt-1 text-[11px] text-red-500">
                    {errors.autreNationalite}
                  </p>
                )}

                {data.autreNationalite === "oui" && (
                  <div className="mt-3">
                    <label className="block text-xs font-semibold text-slate-700">
                      Pays de la deuxième nationalité{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <input
                      name="paysAutreNationalite"
                      value={data.paysAutreNationalite}
                      onChange={handleChange}
                      className="mt-1 w-full border border-slate-300 rounded-lg px-3 py-2 text-sm"
                    />
                    {errors.paysAutreNationalite && (
                      <p className="mt-1 text-[11px] text-red-500">
                        {errors.paysAutreNationalite}
                      </p>
                    )}
                  </div>
                )}
              </div>

              <div>
                <p className="text-xs font-semibold text-slate-700">
                  Êtes-vous résident permanent ou titulaire d’un titre de voyage /
                  carte de résidence ? <span className="text-red-500">*</span>
                </p>
                <div className="mt-1 flex gap-3 text-xs">
                  <button
                    type="button"
                    onClick={() => handleYesNo("residentPermanent", "oui")}
                    className={`px-3 py-1 rounded-lg border ${
                      data.residentPermanent === "oui"
                        ? "border-slate-900 bg-slate-100"
                        : "border-slate-300 bg-white"
                    }`}
                  >
                    Oui
                  </button>
                  <button
                    type="button"
                    onClick={() => handleYesNo("residentPermanent", "non")}
                    className={`px-3 py-1 rounded-lg border ${
                      data.residentPermanent === "non"
                        ? "border-slate-900 bg-slate-100"
                        : "border-slate-300 bg-white"
                    }`}
                  >
                    Non
                  </button>
                </div>
                {errors.residentPermanent && (
                  <p className="mt-1 text-[11px] text-red-500">
                    {errors.residentPermanent}
                  </p>
                )}
              </div>
            </div>
          )}

          {/* PAGE 3 */}
          {step === 3 && (
            <div className="space-y-4">
              <h2 className="text-sm md:text-base font-semibold text-indigo-900">
                3. État civil & activité
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-semibold text-slate-700">
                    État civil <span className="text-red-500">*</span>
                  </label>
                  <select
                    name="etatCivil"
                    value={data.etatCivil}
                    onChange={handleChange}
                    className="mt-1 w-full border border-slate-300 rounded-lg px-3 py-2 text-sm"
                  >
                    <option value="">Sélectionnez</option>
                    <option value="celibataire">Célibataire</option>
                    <option value="marie">Marié(e)</option>
                    <option value="divorce">Divorcé(e)</option>
                    <option value="veuf">Veuf(ve)</option>
                  </select>
                  {errors.etatCivil && (
                    <p className="mt-1 text-[11px] text-red-500">
                      {errors.etatCivil}
                    </p>
                  )}
                </div>
                <div>
                  <label className="block text-xs font-semibold text-slate-700">
                    Intitulé du poste / métier{" "}
                    <span className="text-red-500">*</span>
                  </label>
                  <input
                    name="titreEmploi"
                    value={data.titreEmploi}
                    onChange={handleChange}
                    placeholder="Ex : Infirmier, Étudiant, Commercial..."
                    className="mt-1 w-full border border-slate-300 rounded-lg px-3 py-2 text-sm"
                  />
                  {errors.titreEmploi && (
                    <p className="mt-1 text-[11px] text-red-500">
                      {errors.titreEmploi}
                    </p>
                  )}
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                  <label className="block text-xs font-semibold text-slate-700">
                    Pays d’activité <span className="text-red-500">*</span>
                  </label>
                  <input
                    name="paysEmploi"
                    value={data.paysEmploi}
                    onChange={handleChange}
                    className="mt-1 w-full border border-slate-300 rounded-lg px-3 py-2 text-sm"
                  />
                  {errors.paysEmploi && (
                    <p className="mt-1 text-[11px] text-red-500">
                      {errors.paysEmploi}
                    </p>
                  )}
                </div>
                <div>
                  <label className="block text-xs font-semibold text-slate-700">
                    Ville d’activité <span className="text-red-500">*</span>
                  </label>
                  <input
                    name="villeEmploi"
                    value={data.villeEmploi}
                    onChange={handleChange}
                    className="mt-1 w-full border border-slate-300 rounded-lg px-3 py-2 text-sm"
                  />
                  {errors.villeEmploi && (
                    <p className="mt-1 text-[11px] text-red-500">
                      {errors.villeEmploi}
                    </p>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* PAGE 4 */}
          {step === 4 && (
            <div className="space-y-4">
              <h2 className="text-sm md:text-base font-semibold text-indigo-900">
                4. Coordonnées postales
              </h2>

              <div>
                <label className="block text-xs font-semibold text-slate-700">
                  Adresse (où vous habitez){" "}
                  <span className="text-red-500">*</span>
                </label>
                <input
                  name="adresse"
                  value={data.adresse}
                  onChange={handleChange}
                  className="mt-1 w-full border border-slate-300 rounded-lg px-3 py-2 text-sm"
                />
                {errors.adresse && (
                  <p className="mt-1 text-[11px] text-red-500">
                    {errors.adresse}
                  </p>
                )}
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                  <label className="block text-xs font-semibold text-slate-700">
                    Code postal <span className="text-red-500">*</span>
                  </label>
                  <input
                    name="codePostal"
                    value={data.codePostal}
                    onChange={handleChange}
                    className="mt-1 w-full border border-slate-300 rounded-lg px-3 py-2 text-sm"
                  />
                  {errors.codePostal && (
                    <p className="mt-1 text-[11px] text-red-500">
                      {errors.codePostal}
                    </p>
                  )}
                </div>
                <div>
                  <label className="block text-xs font-semibold text-slate-700">
                    Ville <span className="text-red-500">*</span>
                  </label>
                  <input
                    name="ville"
                    value={data.ville}
                    onChange={handleChange}
                    className="mt-1 w-full border border-slate-300 rounded-lg px-3 py-2 text-sm"
                  />
                  {errors.ville && (
                    <p className="mt-1 text-[11px] text-red-500">
                      {errors.ville}
                    </p>
                  )}
                </div>
                <div>
                  <label className="block text-xs font-semibold text-slate-700">
                    Pays <span className="text-red-500">*</span>
                  </label>
                  <input
                    name="paysResidence"
                    value={data.paysResidence}
                    onChange={handleChange}
                    className="mt-1 w-full border border-slate-300 rounded-lg px-3 py-2 text-sm"
                  />
                  {errors.paysResidence && (
                    <p className="mt-1 text-[11px] text-red-500">
                      {errors.paysResidence}
                    </p>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* PAGE 5 */}
          {step === 5 && (
            <div className="space-y-4">
              <h2 className="text-sm md:text-base font-semibold text-indigo-900">
                5. Antécédents & santé
              </h2>

              <div>
                <p className="text-xs font-semibold text-slate-700">
                  Avez-vous déjà essuyé un refus de visa / permis / entrée ou un ordre de
                  quitter un pays ? <span className="text-red-500">*</span>
                </p>
                <div className="mt-1 flex gap-3 text-xs">
                  <button
                    type="button"
                    onClick={() => handleYesNo("refusVisa", "oui")}
                    className={`px-3 py-1 rounded-lg border ${
                      data.refusVisa === "oui"
                        ? "border-slate-900 bg-slate-100"
                        : "border-slate-300 bg-white"
                    }`}
                  >
                    Oui
                  </button>
                  <button
                    type="button"
                    onClick={() => handleYesNo("refusVisa", "non")}
                    className={`px-3 py-1 rounded-lg border ${
                      data.refusVisa === "non"
                        ? "border-slate-900 bg-slate-100"
                        : "border-slate-300 bg-white"
                    }`}
                  >
                    Non
                  </button>
                </div>
                {errors.refusVisa && (
                  <p className="mt-1 text-[11px] text-red-500">
                    {errors.refusVisa}
                  </p>
                )}
                {data.refusVisa === "oui" && (
                  <textarea
                    name="detailsRefusVisa"
                    value={data.detailsRefusVisa}
                    onChange={handleChange}
                    rows={3}
                    placeholder="Ville, pays, date, type de refus..."
                    className="mt-2 w-full border border-slate-300 rounded-lg px-3 py-2 text-sm"
                  />
                )}
                {errors.detailsRefusVisa && (
                  <p className="mt-1 text-[11px] text-red-500">
                    {errors.detailsRefusVisa}
                  </p>
                )}
              </div>

              <div>
                <p className="text-xs font-semibold text-slate-700">
                  Avez-vous déjà commis / été arrêté / inculpé / reconnu coupable d’une
                  infraction pénale ? <span className="text-red-500">*</span>
                </p>
                <div className="mt-1 flex gap-3 text-xs">
                  <button
                    type="button"
                    onClick={() => handleYesNo("infractionPenale", "oui")}
                    className={`px-3 py-1 rounded-lg border ${
                      data.infractionPenale === "oui"
                        ? "border-slate-900 bg-slate-100"
                        : "border-slate-300 bg-white"
                    }`}
                  >
                    Oui
                  </button>
                  <button
                    type="button"
                    onClick={() => handleYesNo("infractionPenale", "non")}
                    className={`px-3 py-1 rounded-lg border ${
                      data.infractionPenale === "non"
                        ? "border-slate-900 bg-slate-100"
                        : "border-slate-300 bg-white"
                    }`}
                  >
                    Non
                  </button>
                </div>
                {errors.infractionPenale && (
                  <p className="mt-1 text-[11px] text-red-500">
                    {errors.infractionPenale}
                  </p>
                )}
                {data.infractionPenale === "oui" && (
                  <textarea
                    name="detailsInfractionPenale"
                    value={data.detailsInfractionPenale}
                    onChange={handleChange}
                    rows={3}
                    placeholder="Ville, pays, date, nature de l’infraction et peine..."
                    className="mt-2 w-full border border-slate-300 rounded-lg px-3 py-2 text-sm"
                  />
                )}
                {errors.detailsInfractionPenale && (
                  <p className="mt-1 text-[11px] text-red-500">
                    {errors.detailsInfractionPenale}
                  </p>
                )}
              </div>

              <div>
                <p className="text-xs font-semibold text-slate-700">
                  Au cours des 2 dernières années, tuberculose ou contact étroit avec une
                  personne atteinte ? <span className="text-red-500">*</span>
                </p>
                <div className="mt-1 flex gap-3 text-xs">
                  <button
                    type="button"
                    onClick={() => handleYesNo("tuberculoseRecent", "oui")}
                    className={`px-3 py-1 rounded-lg border ${
                      data.tuberculoseRecent === "oui"
                        ? "border-slate-900 bg-slate-100"
                        : "border-slate-300 bg-white"
                    }`}
                  >
                    Oui
                  </button>
                  <button
                    type="button"
                    onClick={() => handleYesNo("tuberculoseRecent", "non")}
                    className={`px-3 py-1 rounded-lg border ${
                      data.tuberculoseRecent === "non"
                        ? "border-slate-900 bg-slate-100"
                        : "border-slate-300 bg-white"
                    }`}
                  >
                    Non
                  </button>
                </div>
                {errors.tuberculoseRecent && (
                  <p className="mt-1 text-[11px] text-red-500">
                    {errors.tuberculoseRecent}
                  </p>
                )}
              </div>

              <div>
                <p className="text-xs font-semibold text-slate-700">
                  Souffrez-vous de l’une de ces affections ?{" "}
                  <span className="text-red-500">*</span>
                </p>
                <div className="mt-1 space-y-2 text-xs">
                  <label className="flex items-center gap-2">
                    <input
                      type="radio"
                      name="affection"
                      checked={data.affection === "syphilis"}
                      onChange={() =>
                        setData((prev) => ({ ...prev, affection: "syphilis" }))
                      }
                    />
                    <span>Syphilis</span>
                  </label>
                  <label className="flex items-center gap-2">
                    <input
                      type="radio"
                      name="affection"
                      checked={data.affection === "dependance"}
                      onChange={() =>
                        setData((prev) => ({ ...prev, affection: "dependance" }))
                      }
                    />
                    <span>Dépendance aux drogues ou à l’alcool</span>
                  </label>
                  <label className="flex items-center gap-2">
                    <input
                      type="radio"
                      name="affection"
                      checked={data.affection === "trouble"}
                      onChange={() =>
                        setData((prev) => ({ ...prev, affection: "trouble" }))
                      }
                    />
                    <span>Trouble mental non traité avec psychoses</span>
                  </label>
                  <label className="flex items-center gap-2">
                    <input
                      type="radio"
                      name="affection"
                      checked={data.affection === "aucune"}
                      onChange={() =>
                        setData((prev) => ({ ...prev, affection: "aucune" }))
                      }
                    />
                    <span>Aucune des réponses</span>
                  </label>
                </div>
                {errors.affection && (
                  <p className="mt-1 text-[11px] text-red-500">
                    {errors.affection}
                  </p>
                )}
              </div>
            </div>
          )}

          {/* PAGE 6 – Validation & paiement */}
          {step === 6 && (
            <div className="space-y-6">
              <h2 className="text-sm md:text-base font-semibold text-indigo-900">
                6. Validation finale & paiement sécurisé
              </h2>

              {/* 🔍 Récap rapide */}
              <div className="border border-indigo-100 rounded-xl p-4 bg-white shadow-sm space-y-2">
                <p className="text-[11px] uppercase tracking-wide text-indigo-600 font-semibold">
                  Récapitulatif du dossier
                </p>
                <p className="text-xs md:text-sm text-slate-700">
                  Voyageur :{" "}
                  <span className="font-semibold">
                    {data.prenoms || "Prénom"} {data.nom || "Nom"}
                  </span>
                </p>
                <p className="text-xs md:text-sm text-slate-700">
                  Destination :{" "}
                  <span className="font-semibold">
                    {data.destination === "usa"
                      ? "États-Unis (ESTA)"
                      : data.destination === "canada"
                      ? "Canada (eTA)"
                      : data.destination === "australie"
                      ? "Australie (ETA)"
                      : "Pays sélectionné"}
                  </span>
                </p>
                <p className="text-xs md:text-sm text-slate-700">
                  Nationalité :{" "}
                  <span className="font-semibold">
                    {data.country || "Non précisée"}
                  </span>
                </p>

                <div className="mt-3 border-t pt-3 flex items-center justify-between">
                  <div>
                    <p className="text-[11px] text-slate-500">Total à régler</p>
                    <p className="text-lg md:text-xl font-extrabold text-slate-900 leading-tight">
                      98,00 € TTC
                    </p>
                    <p className="text-[10px] text-slate-500">
                      Frais officiels + service de traitement
                    </p>
                  </div>
                  <div className="text-right text-[10px] text-slate-500">
                    <p>Paiement sécurisé Stripe</p>
                    <p>Aucune donnée bancaire stockée chez nous.</p>
                  </div>
                </div>
              </div>

              {/* Déclaration du demandeur */}
              <div className="border border-slate-200 rounded-lg p-3 md:p-4 bg-slate-50 space-y-3">
                <h3 className="text-xs md:text-sm font-semibold text-slate-800">
                  Déclaration du demandeur
                </h3>
                <p className="text-[11px] md:text-xs text-slate-700 leading-relaxed">
                  Je déclare que les informations fournies sont exactes. Je comprends
                  que toute fausse déclaration peut entraîner le refus de ma demande
                  ou des poursuites éventuelles.
                </p>

                <label className="flex items-start gap-2 text-[11px] md:text-xs text-slate-700">
                  <input
                    type="checkbox"
                    checked={data.declarationAcceptee}
                    onChange={(e) =>
                      setData((prev) => ({
                        ...prev,
                        declarationAcceptee: e.target.checked,
                      }))
                    }
                    className="mt-[2px]"
                  />
                  <span>
                    Je confirme avoir lu et compris cette déclaration et j’y adhère.
                  </span>
                </label>
                {errors.declarationAcceptee && (
                  <p className="mt-1 text-[11px] text-red-500">
                    {errors.declarationAcceptee}
                  </p>
                )}

                <div>
                  <label className="block text-[11px] md:text-xs font-semibold text-slate-700">
                    Nom complet (signature électronique){" "}
                    <span className="text-red-500">*</span>
                  </label>
                  <input
                    name="declarationNom"
                    value={data.declarationNom}
                    onChange={handleChange}
                    placeholder="Saisissez votre nom comme sur le passeport"
                    className="mt-1 w-full border border-slate-300 rounded-lg px-3 py-2 text-sm"
                  />
                  {errors.declarationNom && (
                    <p className="mt-1 text-[11px] text-red-500">
                      {errors.declarationNom}
                    </p>
                  )}
                </div>
              </div>

              {/* Autorisation par un tiers */}
              <div className="border border-slate-200 rounded-lg p-3 md:p-4 bg-slate-50 space-y-3">
                <h3 className="text-xs md:text-sm font-semibold text-slate-800">
                  Autorisation de traitement
                </h3>
                <p className="text-[11px] md:text-xs text-slate-700 leading-relaxed">
                  J’autorise l’entreprise à vérifier, compléter et soumettre ma
                  demande en mon nom. Je comprends qu’il s’agit d’un service privé
                  non affilié aux autorités officielles.
                </p>

                <label className="flex items-start gap-2 text-[11px] md:text-xs text-slate-700">
                  <input
                    type="checkbox"
                    checked={data.tiersAutorisationAcceptee}
                    onChange={(e) =>
                      setData((prev) => ({
                        ...prev,
                        tiersAutorisationAcceptee: e.target.checked,
                      }))
                    }
                    className="mt-[2px]"
                  />
                  <span>
                    J’autorise l’entreprise à agir comme intermédiaire pour le
                    traitement de ma demande.
                  </span>
                </label>
                {errors.tiersAutorisationAcceptee && (
                  <p className="mt-1 text-[11px] text-red-500">
                    {errors.tiersAutorisationAcceptee}
                  </p>
                )}
              </div>

              {/* Message d'erreur paiement */}
              {paymentError && (
                <p className="text-[11px] text-red-500">
                  {paymentError}
                </p>
              )}

              {/* Bouton de paiement */}
              <button
                type="submit"
                disabled={isPaying}
                className="w-full inline-flex items-center justify-center px-6 py-3 rounded-xl bg-emerald-600 text-white font-semibold text-sm md:text-base shadow-sm disabled:opacity-60"
              >
                {isPaying
                  ? "Redirection vers le paiement sécurisé..."
                  : "Payer 98,00 € et finaliser ma demande"}
              </button>

              {orderId && (
                <p className="text-[10px] text-center text-slate-500">
                  Votre numéro de dossier sera :{" "}
                  <span className="font-mono font-semibold">{orderId}</span>. 
                  Pensez à le conserver pour tout suivi de votre demande.
                </p>
              )}
            </div>
          )}

          {/* NAVIGATION */}
          <div className="pt-4 flex items-center justify-between">
            <button
              type="button"
              onClick={prevStep}
              disabled={step === 1}
              className="text-xs md:text-sm px-4 py-2 rounded-lg border border-slate-300 disabled:opacity-40"
            >
              Précédent
            </button>

            {step < totalSteps && (
              <button
                type="button"
                onClick={nextStep}
                className="text-xs md:text-sm px-5 py-2.5 rounded-md bg-slate-900 text-white font-semibold hover:bg-slate-800 transition"
                >
                Suivant ➜
              </button>
            )}
          </div>
        </form>
      </section>

      {/* Popup resident */}
      {showResidentModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-lg max-w-sm w-full p-5">
            <h3 className="text-sm font-semibold text-indigo-900 mb-2">
              Info résident permanent
            </h3>
            <p className="text-xs text-slate-600 mb-4">
              Si vous êtes résident permanent ou titulaire d’un titre de voyage pour
              résident permanent / carte de résidence, vous n’avez souvent pas besoin
              d’ETA/ESTA. Vérifiez les règles officielles du pays de destination.
            </p>
            <button
              onClick={() => setShowResidentModal(false)}
              className="text-xs px-4 py-2 rounded-lg bg-indigo-600 text-white font-semibold w-full"
            >
              J’ai compris
            </button>
          </div>
        </div>
      )}
    </main>
  );
}
